/*
 * Copyright 2025 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const defaultTemplates = [
  '@backstage/cli-module-new/templates/frontend-plugin',
  '@backstage/cli-module-new/templates/frontend-plugin-module',
  '@backstage/cli-module-new/templates/legacy-frontend-plugin',
  '@backstage/cli-module-new/templates/backend-plugin',
  '@backstage/cli-module-new/templates/backend-plugin-module',
  '@backstage/cli-module-new/templates/plugin-web-library',
  '@backstage/cli-module-new/templates/plugin-node-library',
  '@backstage/cli-module-new/templates/plugin-common-library',
  '@backstage/cli-module-new/templates/web-library',
  '@backstage/cli-module-new/templates/node-library',
  '@backstage/cli-module-new/templates/cli-module',
  '@backstage/cli-module-new/templates/catalog-provider-module',
  '@backstage/cli-module-new/templates/scaffolder-backend-module',
  '@backstage/cli-module-new/templates/scaffolder-field-extension-module',
];
